"use client";
import Link from "next/link";
import { useSearchParams } from "next/navigation";
import { useCallback, useState } from "react";
import { FaRepeat } from "react-icons/fa6";
import { useSession } from "next-auth/react";
import UserMenu from "./UserMenu";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);

  const searchParams = useSearchParams();
  const { data: session } = useSession();

  // Función para cerrar el menú
  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const toggleMenu = useCallback(() => {
    setIsMenuOpen((prev) => !prev);
    setIsUserMenuOpen(false);
  }, []);

  const toggleUserMenu = useCallback(() => {
    setIsUserMenuOpen((prev) => !prev);
    setIsMenuOpen(false);
  }, []);

  const buildUrlWithParams = (hash: string) => {
    const currentParams = searchParams?.toString();
    const cleanHash = hash.replace("#", "");
    return currentParams
      ? `/boilerplate?${currentParams}#${cleanHash}`
      : `/boilerplate#${cleanHash}`;
  };

  // Solo mostrar UserMenu si el usuario es ADMIN
  const showUserMenu = session?.user?.role === "ADMIN";

  return (
    <nav className="bg-gray-900 border-b border-gray-800 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          <div className="flex items-center">
            <div className="w-6 h-6 flex items-center justify-center rounded-md bg-cyan-400 text-white">
              <FaRepeat className="text-white" />
            </div>
            <Link
              href="/"
              className="ml-2 text-2xl font-bold font-mono text-white"
            >
              Peer<span className="text-cyan-400">Q</span>uik
            </Link>
          </div>

          <div className="hidden md:flex items-center space-x-8 font-semibold">
            <Link href="/publish" className="text-white hover:text-cyan-400">
              TikTok workspace
            </Link>
            <Link
              href={buildUrlWithParams("#pricing")}
              className="text-white hover:text-cyan-400"
            >
              Pricing
            </Link>
            <Link
              href={buildUrlWithParams("#demo")}
              className="text-white hover:text-cyan-400"
            >
              Demo
            </Link>
            <a
              href="https://x.com/eliana_jordan"
              className="text-white hover:text-cyan-400"
            >
              Contact
            </a>
            {showUserMenu && (
              <UserMenu isOpen={isUserMenuOpen} toggleOpen={toggleUserMenu} />
            )}
          </div>

          <div className="md:hidden flex items-center">
            <button
              aria-label="Toggle navigation"
              aria-expanded={isMenuOpen}
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-white hover:text-cyan-400"
            >
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16m-7 6h7"
                />
              </svg>
            </button>
            {showUserMenu && (
              <div className="pl-2 pt-2">
                <UserMenu isOpen={isUserMenuOpen} toggleOpen={toggleUserMenu} />
              </div>
            )}
          </div>
        </div>
      </div>

      {isMenuOpen && (
        <div className="md:hidden bg-black border-t border-gray-800">
          <div className="px-4 pt-4 pb-3 space-y-3 font-semibold">
            <Link
              href="/publish"
              className="block text-white hover:text-cyan-400"
              onClick={closeMenu}
            >
              TikTok workspace
            </Link>
            <Link
              href={buildUrlWithParams("#pricing")}
              className="block text-white hover:text-cyan-400"
              onClick={closeMenu}
            >
              Pricing
            </Link>
            <Link
              href={buildUrlWithParams("#demo")}
              className="block text-white hover:text-cyan-400"
              onClick={closeMenu}
            >
              Demo
            </Link>
            <a
              href="https://x.com/eliana_jordan"
              className="block text-white hover:text-cyan-400"
              onClick={closeMenu}
            >
              Contact
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
